import { Body, Layout } from 'components';
import { CSSObject, GlobalStyles, styled } from 'libs/ui/styled';

export const WrapperStyled = styled('div')(() => ({
  margin: '32px 0',
  display: 'flex',
  flex: 1,
}));

export const ContentStyled = styled(Body)(({ theme }) => ({
  maxWidth: 896,

  [theme.breakpoints.up('mobile')]: {
    justifyContent: 'center',
    padding: 64,
    margin: 'auto',
  },
  [theme.breakpoints.down('tablet')]: {
    maxWidth: '100%',
  } as CSSObject,
}));

export const OverrideStyles = () => (
  <GlobalStyles
    styles={() => ({
      [Layout.classes.main.css]: {
        [Layout.classes.footer.css]: {
          height: '0 !important',
        } as CSSObject,
      },
    })}
  />
);
